import React, { useState } from 'react'
import { Button } from './ui/button'
import { Input } from './ui/input'
import { toast } from 'react-hot-toast'

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [resetUrl, setResetUrl] = useState(null)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!email) return
    setLoading(true)
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.detail || 'Fehler')
      setSubmitted(true)
      if (data.reset_url) setResetUrl(data.reset_url)
    } catch (err) {
      toast.error(err.message)
    } finally {
      setLoading(false)
    }
  }

  if (submitted) {
    return (
      <div className="text-center space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-2">
          <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-slate-800">E-Mail gesendet!</h3>
        <p className="text-sm text-slate-600">
          Falls diese E-Mail bei uns registriert ist, erhalten Sie einen Reset-Link.
        </p>
        {resetUrl && (
          <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-left">
            <p className="text-xs font-semibold text-amber-700 mb-1">🛠 Entwicklungsmodus: Link direkt hier</p>
            <a
              href={resetUrl}
              className="text-xs text-blue-600 break-all underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {resetUrl}
            </a>
          </div>
        )}
        <Button variant="link" onClick={onBack} className="text-blue-600 mt-2">
          ← Zurück zum Login
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-slate-800">Passwort vergessen?</h3>
        <p className="text-sm text-slate-500 mt-1">
          Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Reset-Link.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="email"
          placeholder="ihre@email.de"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={loading}
        />
        <Button
          type="submit"
          disabled={loading || !email}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white"
        >
          {loading ? (
            <span className="flex items-center gap-2">
              <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"/>
              </svg>
              Sende...
            </span>
          ) : 'Reset-Link anfordern'}
        </Button>
      </form>
      <div className="text-center">
        <Button variant="link" onClick={onBack} className="text-slate-500 text-sm">
          ← Zurück zum Login
        </Button>
      </div>
    </div>
  )
}

export default ForgotPassword
